import { styled } from '@defa/defa-component-library';

export const Texts = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
`;
